import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'userLogout',
  initialState: true,
  reducers: {
    setUserLogout(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setUserLogout } = slice.actions;

export default slice.reducer;
